// tanstack
import { createFileRoute } from '@tanstack/react-router';

// feature-components
import EnergyTreeNodeChildAnalysisPage from '@/features/energyxplorer/components/analysis/EnergyTreeNodeChildAnalysisPage';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/$analysisType/$energyGroupId/child-analysis',
)({
  component: EnergyTreeNodeChildAnalysisPage,
});
